import { useState } from "react";
import { Helmet } from "react-helmet-async";
import AnnouncementBar from "@/components/dibs_landing_page/AnnouncementBar";
import Navbar from "@/components/dibs_landing_page/Navbar";
import Footer from "@/components/dibs_landing_page/Footer";
import LandingPage from "@/components/dibs_landing_page/LandingPage";
import { faqs, offers } from "@/components/dibs_landing_page/landingV2Data";

const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map(([question, answer]) => ({
    "@type": "Question",
    name: question,
    acceptedAnswer: { "@type": "Answer", text: answer },
  })),
};

const offersJsonLd = {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  name: "Dibs",
  applicationCategory: "BusinessApplication",
  operatingSystem: "Web",
  offers: offers
    .filter((o) => typeof o.monthly === "number")
    .map((o) => ({
      "@type": "Offer",
      name: o.name,
      price: o.monthly,
      priceCurrency: "SGD",
      description: o.audience,
    })),
};

// Module-level, not persisted: a dismissal lasts until the page is refreshed, so the bar returns on every reload.
let dismissedThisLoad = false;

export default function Index() {
  const [dismissed, setDismissed] = useState(dismissedThisLoad);

  const dismiss = () => {
    dismissedThisLoad = true;
    setDismissed(true);
  };

  return (
    <>
      <Helmet>
        <title>Dibs: AI engagement platform and B2C CRM | WhatsApp & more</title>
        <meta name="description" content="Dibs is the AI engagement platform and B2C CRM that keeps customers coming back. Unify your inbox, automate follow-ups and rebookings, and grow repeat revenue. Based in Singapore." />
        <link rel="canonical" href="https://www.usedibs.com/" />
        <meta property="og:title" content="Dibs: AI engagement platform and B2C CRM | WhatsApp & more" />
        <meta property="og:description" content="Dibs is the AI engagement platform and B2C CRM that keeps customers coming back. Unify your inbox, automate follow-ups and rebookings, and grow repeat revenue. Based in Singapore." />
        <meta property="og:url" content="https://www.usedibs.com/" />
        <meta name="twitter:title" content="Dibs: AI engagement platform and B2C CRM | WhatsApp & more" />
        <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
        <script type="application/ld+json">{JSON.stringify(offersJsonLd)}</script>
        <meta name="twitter:description" content="Dibs is the AI engagement platform and B2C CRM that keeps customers coming back. Unify your inbox, automate follow-ups and rebookings, and grow repeat revenue. Based in Singapore." />
      </Helmet>
      <a href="#main-content" className="dv-skip-link">
        Skip to content
      </a>
      <Navbar
        announcement={dismissed ? null : <AnnouncementBar onDismiss={dismiss} />}
      />
      <LandingPage />
      <Footer />
    </>
  );
}
